export default __webpack_public_path__ + "static/media/cats.57a6155e.webp";